import styled from 'styled-components';

import { setMobileView } from '../../../tools/mobileView';

export const AddressContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${setMobileView() ? '280px' : '320px'};
`;

export const AddressTopContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

export const AddressBottomContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
`;

export const AddressInput = styled.input`
    width:  ${setMobileView() ? '260px' : '300px'};
    margin: 5px 0;
    padding: 3px;
`;

export const AddressZipCodeInput = styled.input`
    width:  ${setMobileView() ? '45px' : '55px'};
    margin: 5px 0;
    padding: 3px;
`;

export const AddressCityInput = styled.input`
    width:  ${setMobileView() ? '125px' : '140px'};
    margin: 5px 0;
    padding: 3px;
`;

export const AddressDropdown = styled.select`
    width:  ${setMobileView() ? '60px' : '70px'};
    margin: 5px 10px;
    font-size: 12px !important;
    color: black;
`;

export const AddressDropdownOption = styled.option`

`;